module["exports"] = [
  "se",
  "nu",
  "info",
  "com",
  "org"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/internet/domain_suffix.js
// module id = 1725
// module chunks = 0